import React from 'react';
import { ProIcon } from '../../../components/common/SvgIcon';

const TemplateTabs = ({ activeTab, counts, onTabChange }) => {
  const tabs = [
    { key: 'all', label: 'All', count: counts.all },
    { key: 'free', label: 'Free', count: counts.free },
    { key: 'pro', label: 'Pro', count: counts.pro },
  ];

  return (
    <div className="flex gap-2">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`
            flex items-center gap-2 cursor-pointer
            px-4 py-2 rounded-xl font-medium text-sm transition-all
            ${activeTab === tab.key
              ? 'bg-lgp-color text-white'
              : 'bg-white text-[#6F6F7B] border border-[#E4E4E7] hover:border-[#17171C]'
            }
          `}
        >
          <span>{tab.label}</span>
          <span
            className={`
              ml-1 px-2 py-0.5 rounded-full text-xs
              ${activeTab === tab.key
                ? 'bg-white/20 text-white'
                : 'bg-[#F4F4F5] text-[#6F6F7B]'
              }
            `}
          >
            {tab.count}
          </span>
            {tab.key === 'pro' && (
              <span className="flex items-center">
                {ProIcon}
              </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TemplateTabs;
